import { AddingCheckControl } from "./AddingCheckControl";
import React, { useMemo } from "react";
import { buildConditionedPath } from "./HelpersConditional";
import { usePathContext } from "../PathInfo";
import { useConditionalContext } from "./ConditionalContext";

interface ToggleConditionalProps {
  renderDefaultControls?: boolean;
  isConditional: boolean;
}

export function ToggleConditional(props: ToggleConditionalProps) {
  const { path } = usePathContext();
  const { selectedCondition, conditions, unconditionedName } = useConditionalContext();

  const conditionedPropName = useMemo(() => {
    return buildConditionedPath(selectedCondition!, unconditionedName, conditions!, "condition");
  }, [conditions, selectedCondition, unconditionedName]);

  if (props.isConditional) {
    return <></>;
  }

  return <AddingCheckControl allChecks={{}} conditionArray={[]} path={path.concat(conditionedPropName)} />;
}
